// extracted by mini-css-extract-plugin
export default {"home":"UpdateQuiz_home__zUuFb","hr":"UpdateQuiz_hr__Ejh8+","home2":"UpdateQuiz_home2__6xA+m","main":"UpdateQuiz_main__MZorq"};